/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Group_Not_An_AdministratorInputs */

const en_us2_group_not_an_administrator = /** @type {(inputs: Group_Not_An_AdministratorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Only the group's administrators can do that.`)
};

const pt_br2_group_not_an_administrator = /** @type {(inputs: Group_Not_An_AdministratorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Só quem administra a turma pode fazer isso.`)
};

const pt_pt2_group_not_an_administrator = /** @type {(inputs: Group_Not_An_AdministratorInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Só quem administra a turma pode fazer isso.`)
};

/** @type {(inputs: Group_Not_An_AdministratorInputs) => LocalizedString} */
const es_419_group_not_an_administrator = en_us2_group_not_an_administrator;

/** @type {(inputs: Group_Not_An_AdministratorInputs) => LocalizedString} */
const fr_fr2_group_not_an_administrator = en_us2_group_not_an_administrator;

/** @type {(inputs: Group_Not_An_AdministratorInputs) => LocalizedString} */
const de_de2_group_not_an_administrator = en_us2_group_not_an_administrator;

/** @type {(inputs: Group_Not_An_AdministratorInputs) => LocalizedString} */
const it_it2_group_not_an_administrator = en_us2_group_not_an_administrator;

/**
* | output |
* | --- |
* | "Only the group's administrators can do that." |
*
* @param {Group_Not_An_AdministratorInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const group_not_an_administrator = /** @type {((inputs?: Group_Not_An_AdministratorInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Group_Not_An_AdministratorInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_group_not_an_administrator(inputs)
	if (locale === "es-419") return es_419_group_not_an_administrator(inputs)
	if (locale === "pt-PT") return pt_pt2_group_not_an_administrator(inputs)
	if (locale === "fr-FR") return fr_fr2_group_not_an_administrator(inputs)
	if (locale === "de-DE") return de_de2_group_not_an_administrator(inputs)
	if (locale === "it-IT") return it_it2_group_not_an_administrator(inputs)
	return en_us2_group_not_an_administrator(inputs)
});
export { group_not_an_administrator as "group.not_an_administrator" }